module.exports = __webpack_public_path__ + "img/dimsum-3.ba8d3cb5.jpg";